export enum StreamingEuStep {
  ProviderLicense = "ProviderLicense",
  UserEntitlementData = "UserEntitlementData",
  ProviderInformationMandatory = "ProviderInformationMandatory",
  ProviderInformationOptional = "ProviderInformationOptional",
  AccessToEntitlementData = "AccessToEntitlementData",
  TermsAndConditions = "TermsAndConditions",
  ThankYou = "ThankYou",
  EmailVerify = "EmailVerify",
}

export type StreamingEuStepDefaultProps = Readonly<{
  navigateToStep: (step: StreamingEuStep) => void;
  storeStreamingData: (data: Partial<StreamingEuRequest>) => void;
}>;

export enum StreamingEuDataProviders {
  Tencent = "Tencent",
  Valve = "Valve",
  Nexon = "Nexon",
  NetEase = "NetEase",
  EA = "EA",
  SmileGateEmbracer = "SmileGateEmbracer",
  Roblox = "Roblox",
  TakeTwo = "TakeTwo",
  EpicGames = "EpicGames",
  Ubisoft = "Ubisoft",
  SquareEnix = "SquareEnix",
  BandaiNamco = "BandaiNamco",
  Sony = "Sony",
  Nintendo = "Nintendo",
}

export type StreamingEuRequest = Readonly<{
  accessToEntitlementData: boolean;
  companyName: string;
  contactPersonLastName: string;
  contactPersonFirstName: string;
  companyRole: string;
  contactEmail: string;
  requestedEntitlementData: StreamingEuDataProviders[];
  agreesToTermsAndConditions: boolean;
}>;
